import React from 'react';
import { BrandMark } from '../BrandMark';
import { CTAButton } from '../CTAButton';
import { CountdownTimer } from '../CountdownTimer';
const stats = [{
  value: '300+',
  label: 'Clinical decision pages'
}, {
  value: '6',
  label: 'Specialized volumes'
}, {
  value: '5',
  label: 'Premium bonuses'
}, {
  value: '5 min',
  label: 'Per decision route'
}];
export function Hero() {
  return <header className="relative overflow-hidden bg-cream px-4 pb-14 pt-8 sm:pt-12" data-id="element-185" data-mp="muabw42rrgvk">
      <div className="mx-auto w-full max-w-5xl" data-id="element-186" data-mp="qvm84sg5f0cq">
        <div className="flex flex-col items-center gap-3" data-id="element-187" data-mp="qub2so721kji">
          <BrandMark data-id="element-188" data-mp="vmm51xp9pif8" />
          <span className="rounded-full border border-ink-line bg-white px-3.5 py-1.5 text-[10.5px] font-bold uppercase tracking-[0.12em] text-ink sm:text-xs" data-id="element-189" data-mp="vm2nii3j4w1q">
            🩺 Renal Decision Desk™
          </span>
        </div>

        <h1 className="mt-7 text-center font-display text-[34px] font-bold leading-[1.08] tracking-tight text-ink sm:text-5xl lg:text-[58px]" data-id="element-190" data-mp="15m396aovfo93">
          Make structured renal decisions in{' '}
          <em className="not-italic text-cyan-brand italic font-semibold" data-id="element-191" data-mp="9pdvnqxu08gt">
            under 5 minutes
          </em>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-center text-[15.5px] leading-relaxed text-ink-soft sm:text-lg" data-id="element-192" data-mp="4r2jh9k2dlvf">
          From an elevated creatinine to medication questions, abnormal
          potassium, CKD follow-up and referral decisions — use a visual
          clinical decision system to identify the scenario, follow the right
          route, and organize your next steps. Includes{' '}
          <strong className="font-bold text-ink" data-id="element-193" data-mp="nhk04frmgr0f">6 decision volumes</strong>,{' '}
          <strong className="font-bold text-ink" data-id="element-194" data-mp="imo8vhu7m7od">5 premium bonuses</strong> and{' '}
          <strong className="font-bold text-ink" data-id="element-195" data-mp="eme0jyiy356c">
            300+ clinical decision pages
          </strong>
          .
        </p>

        <div className="mt-8" data-id="element-196" data-mp="1b6msoinso49p">
          <img src="https://cdn.magicpatterns.com/uploads/uHxYHff5uV6SeyYD8BUpJt/RENALDESK-EN.png" alt="Renal Decision Desk™ complete system: six clinical volumes, laptop, tablet, phone and decision cards" className="mx-auto w-full max-w-3xl" width={1080} height={1080} data-id="element-197" data-mp="16dtl7n0xyhtx" />
        </div>

        <div className="mt-6" data-id="element-198" data-mp="2qu1fiyx0sksh">
          <CTAButton id="cta-hero" label="Yes — I want Renal Decision Desk™" sub="Instant download • One-time payment of USD $27 • Lifetime access • 7-day guarantee" data-id="element-199" data-mp="2vup4zg5lotkl" />
          <CountdownTimer data-id="element-200" data-mp="2muslru1zcmwx" />
        </div>

        <ul className="mx-auto mt-10 grid w-full max-w-3xl grid-cols-2 gap-2.5 sm:gap-4" data-id="element-201" data-mp="2mvtvnv79f3d2">
          {stats.map(stat => <li key={stat.label} className="rounded-2xl border border-ink-line bg-white px-3 py-4 text-center" data-id="element-202" data-mp="2cwcvtueovjp0">
              <p className="font-display text-2xl font-bold text-ink sm:text-3xl" data-id="element-203" data-mp="66epx3pnao3g">
                {stat.value}
              </p>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-wide text-ink-soft sm:text-xs" data-id="element-204" data-mp="b2lyl49fedp3">
                {stat.label}
              </p>
            </li>)}
        </ul>
      </div>
    </header>;
}